import OneSignal from 'react-onesignal';
import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { ClerkProvider } from "@clerk/clerk-react";

const PUBLISHABLE_KEY = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

// init() only -- AuthContext reads OneSignal.User.PushSubscription.optedIn/
// .id for subscription status, so this still needs to run. The
// auto-firing Slidedown.promptPush() that used to follow it doesn't: it
// fired the browser's native "send notifications?" permission prompt on
// every single page load, for anyone visiting the site, before they'd even
// signed in — including plain web visitors who aren't using the app's
// native push-based launch relay at all. Settings already has an explicit,
// user-initiated Push Notifications toggle (PushRow) for anyone who wants
// to opt in; that's the only place this should ever be requested.
OneSignal.init({
  appId: process.env.REACT_APP_ONESIGNAL_APP_ID,
});

if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      registration.unregister();
    }
  });
}

const clerkAppearance = {
  baseTheme: undefined,
  variables: {
    colorBackground: '#050505',
    colorPrimary: '#7C3AED',
    colorText: '#ffffff',
    colorTextSecondary: '#a1a1aa',
    colorInputBackground: '#0A0A0A',
    colorInputText: '#ffffff',
  },
  elements: {
    card: { backgroundColor: '#0A0A0A', border: '1px solid rgba(255,255,255,0.08)' },
    headerTitle: { color: '#ffffff' },
    headerSubtitle: { color: '#a1a1aa' },
    socialButtonsBlockButton: { backgroundColor: '#0A0A0A', borderColor: 'rgba(255,255,255,0.1)', color: '#ffffff' },
    formFieldInput: { backgroundColor: '#111111', borderColor: 'rgba(255,255,255,0.1)', color: '#ffffff' },
    footerActionLink: { color: '#7C3AED' },
  },
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <ClerkProvider publishableKey={PUBLISHABLE_KEY} appearance={clerkAppearance}>
      <App />
    </ClerkProvider>
  </React.StrictMode>,
);
